import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const getInitialDark = () => {
  if (typeof document === "undefined") return true;
  return document.documentElement.classList.contains("dark");
};

/**
 * Toggles the site between light and dark themes by adding/removing the
 * `dark` class on <html>. The choice is persisted to localStorage and the
 * browser UI color is kept in sync. Defaults to dark.
 */
export default function ThemeToggle({ className = "" }) {
  const [dark, setDark] = useState(getInitialDark);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", dark);

    try {
      localStorage.setItem("theme", dark ? "dark" : "light");
    } catch (e) {
      // Ignore storage errors (e.g. private mode).
    }

    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", dark ? "#0a0a0a" : "#ffffff");
  }, [dark]);

  return (
    <button
      type="button"
      onClick={() => setDark((prev) => !prev)}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      aria-pressed={dark}
      title={dark ? "Light mode" : "Dark mode"}
      className={`flex h-10 w-10 items-center justify-center rounded-full text-neutral-600 transition-colors duration-200 hover:bg-black/5 hover:text-neutral-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-black/30 dark:text-neutral-400 dark:hover:bg-white/5 dark:hover:text-white dark:focus-visible:ring-white/40 ${className}`}
    >
      {dark ? (
        <Sun size={20} aria-hidden="true" />
      ) : (
        <Moon size={20} aria-hidden="true" />
      )}
    </button>
  );
}
